/* eslint-disable */
import * as icon from 'vue-svgicon'
icon.register({
  'fullscreen': {
    width: 16,
    height: 16,
    viewBox: '0 0 48 48',
    data: '<path pid="0" d="M13.53 26.445l2.518 2.518 4.126-4.126a.357.357 0 0 1 .497.001l2.42 2.42a.357.357 0 0 1-.001.496l-4.126 4.125 2.518 2.519c.135.133.086.266-.101.289l-8.989 1.146c-.188.023-.321-.111-.296-.299l1.144-8.988c.024-.187.156-.234.29-.101zm21.237-4.992l1.144-8.988c.025-.188-.108-.322-.296-.299l-8.989 1.146c-.188.023-.236.156-.102.289l2.518 2.519-4.126 4.125a.357.357 0 0 0-.001.496l2.42 2.42a.357.357 0 0 0 .497 0l4.126-4.125 2.519 2.518c.132.134.265.087.29-.101z"/>'
  }
})



// WEBPACK FOOTER //
// ./src/compiled-icons/fullscreen.js